var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0e7ef0c0"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "userDetailsMainContainer" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = ["id"];
const _hoisted_4 = { class: "flex w-[88%] flex-col leading-3 pl-3" };
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "w-[12rem] overflow-hidden truncate text-ellipsis capitalize mt-1 text-xs" };
const _hoisted_7 = { class: "flex flex-row" };
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
    key: 0,
    class: "ml-2 cursor-pointer"
};
const _hoisted_10 = { class: "ml-1" };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = ["id"];
const _hoisted_13 = { class: "flex flex-row items-center w-3/4" };
const _hoisted_14 = { class: "flex w-[88%] flex-col leading-3 pl-3" };
const _hoisted_15 = ["onClick"];
const _hoisted_16 = { class: "w-[12rem] overflow-hidden truncate text-ellipsis capitalize mt-1 text-xs" };
const _hoisted_17 = { class: "flex flex-row" };
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
    key: 0,
    class: "ml-2 cursor-pointer"
};
const _hoisted_20 = {
    key: 1,
    class: "ml-2"
};
import { convertAndFormatSource } from '@/helper/helper';
import { CalendarEventService } from '@/service/CalendarEventService';
import { openEditAppointmentModal, setEventId, setViewActivityLog, } from '@/states/view_appointment';
import { CheckIcon, Edit01Icon, FaceHappyIcon, FaceSadIcon, InfoCircleIcon, LinkExternal01Icon, ListIcon, User01Icon, XCircleIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIActionDropdown, UIAvatar, UITooltip, renderIcon, } from '@gohighlevel/ghl-ui';
import moment from 'moment';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserDetails',
    props: {
        appointments: {
            type: Array,
        },
        contacts: {
            type: Array,
        },
        source: String,
        router: Object,
        timezone: String,
        userDetails: Object,
        userType: String,
        showMenu: Boolean,
        appointmentDetails: Object,
        showDelete: Boolean,
        onClickDelete: Function,
        showRedirectIcon: Boolean,
    },
    setup(__props) {
        const props = __props;
        const { t } = useI18n();
        const tooltip = (source, user) => {
            return `Source : ${convertAndFormatSource(source) || '-'} <br> Booked By: ${(user === null || user === void 0 ? void 0 : user.name) || '-'}  `;
        };
        // Function to handle dropdown actions
        const dropDownActionChange = (key, appointment, userType) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let contact;
            if (userType === 'appointmentAttendee') {
                contact = appointment.contact;
            }
            else
                contact = appointment;
            // If key is 'reschedule' then open the edit appointment modal
            if (key === 'reschedule') {
                openEditAppointmentModal((_a = props.appointmentDetails) === null || _a === void 0 ? void 0 : _a.eventType);
            }
            else if (key === 'contact_detail') {
                // If the key is contact_details then redirect to contacts url
                redirectToContacts(contact.id);
            }
            else if (key === 'activity_log') {
                // If the key is 'activity_log' then open the activity modal
                setEventId(appointment.id);
                setViewActivityLog(true);
            }
            else {
                const { data } = yield CalendarEventService.getEventDetails(appointment.id);
                const appointmentData = {
                    ignoreFreeSlotValidation: true,
                    contact: {
                        id: contact === null || contact === void 0 ? void 0 : contact.id,
                    },
                    startTime: moment(data.appointment.startTime).tz(props.timezone).format(),
                    endTime: moment(data.appointment.endTime).tz(props.timezone).format(),
                    ignoreDateRange: true,
                    toNotify: false,
                    meetingLocationType: 'custom',
                    address: data.appointment.address,
                    channel: 'web_app',
                    source: 'calendar_page',
                    appointmentStatus: data.appointment.appointmentStatus,
                };
                appointmentData.appointmentStatus = key;
                yield CalendarEventService.updateAppointment(appointment.id, appointmentData);
                props.appointments.forEach(x => {
                    if (x.id === appointment.id) {
                        x.appoinmentStatus = appointmentData.appointmentStatus;
                    }
                });
            }
        });
        // Function to redirect to contacts Url based on the contactId
        const redirectToContacts = contactId => {
            const routeData = props.router.resolve({
                name: 'contact_detail-v2',
                params: { contact_id: contactId },
            });
            window.open(routeData.href, '_blank');
        };
        const appointmentDropdownActionOptions = [
            {
                label: t('appointmentModal.confirmed'),
                key: 'confirmed',
                icon: renderIcon(CheckIcon),
            },
            {
                label: t('appointmentModal.showed'),
                key: 'showed',
                icon: renderIcon(FaceHappyIcon),
            },
            {
                label: t('appointmentModal.no_show'),
                key: 'noshow',
                icon: renderIcon(FaceSadIcon),
            },
            {
                label: t('appointmentModal.reschedule'),
                key: 'reschedule',
                icon: renderIcon(Edit01Icon),
            },
            {
                label: t('appointmentModal.view_activity_log'),
                key: 'activity_log',
                icon: renderIcon(ListIcon),
            },
            {
                label: t('appointmentModal.open_contact_detail'),
                key: 'contact_detail',
                icon: renderIcon(User01Icon),
            },
            {
                label: t('appointmentModal.cancel_appointment'),
                key: 'cancelled',
                icon: renderIcon(XCircleIcon),
            },
        ];
        const getContactName = (contact) => {
            return (contact === null || contact === void 0 ? void 0 : contact.name) && contact.name.trim() !== ''
                ? contact.name
                : contact.email;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (__props.appointments)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.appointments, (value, i) => {
                            var _a, _b;
                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                                (value != null)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: value.id,
                                        class: "flex w-full items-center py-2 justify-between",
                                        id: 'contact-details-container-' + ((_a = value === null || value === void 0 ? void 0 : value.contact) === null || _a === void 0 ? void 0 : _a.id)
                                    }, [
                                        (_openBlock(), _createElementBlock("div", {
                                            class: "flex flex-row items-center",
                                            key: i
                                        }, [
                                            (value.contact.initials)
                                                ? (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                    key: 0,
                                                    style: _normalizeStyle({
                                                        color: 'var(--gray-600)',
                                                        backgroundColor: 'var(--gray-100)',
                                                    })
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(value.contact.initials), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["style"]))
                                                : (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                    key: 1,
                                                    class: "bg-gray-100"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                                    ]),
                                                    _: 1
                                                })),
                                            _createElementVNode("div", _hoisted_4, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", {
                                                        class: "text-[13px] font-medium leading-4 text-primary-700 cursor-pointer",
                                                        id: "contact-name-container",
                                                        onClick: ($event) => (redirectToContacts(value.contact.id))
                                                    }, _toDisplayString(getContactName(value.contact)), 9, _hoisted_5),
                                                    _createElementVNode("div", _hoisted_6, _toDisplayString(__props.userType), 1)
                                                ])
                                            ])
                                        ])),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createVNode(_unref(UITooltip), null, {
                                                trigger: _withCtx(() => [
                                                    _createVNode(_unref(InfoCircleIcon), {
                                                        class: "ml-2 w-5 mb-[5px]",
                                                        id: "contact-info-icon"
                                                    })
                                                ]),
                                                default: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        _createElementVNode("p", {
                                                            innerHTML: tooltip((_a = value.createdBy) === null || _a === void 0 ? void 0 : _a.source, value.bookedBy)
                                                        }, null, 8, _hoisted_8)
                                                    ];
                                                }),
                                                _: 2
                                            }, 1024),
                                            (__props.showRedirectIcon)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                                    _createVNode(_unref(LinkExternal01Icon), {
                                                        id: 'contact-details-container-redirect-' + ((_b = value === null || value === void 0 ? void 0 : value.contact) === null || _b === void 0 ? void 0 : _b.id),
                                                        class: "w-5 text-gray-700",
                                                        onClick: ($event) => (redirectToContacts(value.contact.id))
                                                    }, null, 8, ["id", "onClick"])
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createVNode(_unref(UIActionDropdown), {
                                                    id: value === null || value === void 0 ? void 0 : value.id,
                                                    options: appointmentDropdownActionOptions.map(option => Object.assign({}, option, {
                                                        show: option.key !== value.appoinmentStatus,
                                                    })),
                                                    onSelect: val => {
                                                        dropDownActionChange(val, value, 'appointmentAttendee');
                                                    }
                                                }, null, 8, ["id", "options", "onSelect"])
                                            ])
                                        ])
                                    ], 8, _hoisted_3))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                (__props.contacts)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contacts, (value, i) => {
                            return (_openBlock(), _createElementBlock("div", { key: i }, [
                                (value != null)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        id: 'contact-details-container-' + (value === null || value === void 0 ? void 0 : value.id),
                                        key: value.id,
                                        class: "flex w-full items-center py-2 justify-between"
                                    }, [
                                        _createElementVNode("div", _hoisted_13, [
                                            (value.initials)
                                                ? (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                    key: 0,
                                                    style: _normalizeStyle({
                                                        color: 'var(--gray-600)',
                                                        backgroundColor: 'var(--gray-100)',
                                                    })
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(value.initials), 1)
                                                    ]),
                                                    _: 2
                                                }, 1032, ["style"]))
                                                : (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                    key: 1,
                                                    class: "bg-gray-100"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                                    ]),
                                                    _: 1
                                                })),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", null, [
                                                    _createElementVNode("div", {
                                                        class: "text-[13px] font-medium leading-5 text-primary-700 cursor-pointer",
                                                        id: "contact-details-container",
                                                        onClick: ($event) => (redirectToContacts(value.id))
                                                    }, _toDisplayString(getContactName(value)), 9, _hoisted_15)
                                                ]),
                                                _createElementVNode("div", _hoisted_16, _toDisplayString(__props.userType), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _createVNode(_unref(UITooltip), null, {
                                                trigger: _withCtx(() => [
                                                    _createVNode(_unref(InfoCircleIcon), {
                                                        class: "ml-2 w-5 mb-[5px]",
                                                        id: "contact-info-icon"
                                                    })
                                                ]),
                                                default: _withCtx(() => [
                                                    _createElementVNode("p", {
                                                        innerHTML: tooltip(props.source, __props.userDetails)
                                                    }, null, 8, _hoisted_18)
                                                ]),
                                                _: 1
                                            }),
                                            (__props.showRedirectIcon)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createVNode(_unref(LinkExternal01Icon), {
                                                        class: "w-5 text-gray-700",
                                                        onClick: ($event) => (redirectToContacts(value.id))
                                                    }, null, 8, ["onClick"])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (__props.showDelete)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                    _createVNode(_unref(XCloseIcon), {
                                                        class: "w-5 text-gray-700 cursor-pointer",
                                                        onClick: ($event) => (__props.onClickDelete(i)),
                                                        id: 'contact-details-container-delete-' + (value === null || value === void 0 ? void 0 : value.id)
                                                    }, null, 8, ["onClick", "id"])
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ], 8, _hoisted_12))
                                    : _createCommentVNode("", true)
                            ]));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
